import { Group, Stack, Text } from "@mantine/core";
import { FC } from "react";
import { FormatS } from "../../Service/FormatS";
import BookitupDocument, { TaxEntry } from "../../types/BookitupDocument";
import type { DocumentTranslator } from "./documentLanguage";

interface Props {
  bookitupDocument: BookitupDocument;
  smallScaleBusiness: boolean;
  t: DocumentTranslator;
}

const DocumentFinalSummary: FC<Props> = ({
  bookitupDocument,
  smallScaleBusiness,
  t,
}) => {
  const { finalTaxSummary, finalSum, currency } = bookitupDocument;

  const mapTaxEntryUI = (taxEntry: TaxEntry) => {
    const { taxRatePercent, taxAmount } = taxEntry;
    return (
      <Group position="apart">
        <Text>{`${t("vat")} (${taxRatePercent}%)`}</Text>
        <Text>{FormatS.formatPriceWithCurrency(currency, taxAmount)}</Text>
      </Group>
    );
  };

  return (
    <Stack spacing={5} mt="md">
      <Group position="apart">
        <Text weight="bolder">{t("remainingAmountDue")}</Text>
        <Text weight="bolder">
          {FormatS.formatPriceWithCurrency(currency, finalSum)}
        </Text>
      </Group>
      {!smallScaleBusiness && finalTaxSummary.taxEntries.map(mapTaxEntryUI)}
    </Stack>
  );
};

export default DocumentFinalSummary;
